// extracted by mini-css-extract-plugin
export default {"popupContainer":"PopupMessage_popupContainer__LIelP","deathTypeContainer":"PopupMessage_deathTypeContainer__sDtQ1","buttonContainer":"PopupMessage_buttonContainer__0S20R"};